import React from "react";
import {Tooltip} from "@material-ui/core";
import {motion} from "framer-motion";
import SearchIcon from "@material-ui/icons/Search";

export default function PulsingSearchButton({clickFunc, active}) {

    // I have no idea why this has to be so cursed, I think it has to do with the icon being sized via font-size and the rest being sized by pixels...
    const activeStyle = {
        zIndex: 100,
        marginLeft: "10px",
        boxShadow: "0 0 0px 4px #BEDDFD",
        padding: "3px 0 2px 0",
        borderRadius: "5px",
        marginTop: '0.5px',
    }

    const inactiveStyle = {
        zIndex: 100,
        marginLeft: "10px",
        boxShadow: "0 0 0px 4px rgba(0,0,0,0)",
        padding: "3px 0 2px 0",
        borderRadius: "5px",
        marginTop: '0.5px',
    }

    const activeAnims = {
        boxShadow: [
            "0 0 0px 0px #BEDDFD",  // Initial state
            "0 0 0px 4px #BEDDFD", // Animated state
            "0 0 0px 0px #BEDDFD"   // Return to initial state
        ],
    }

    const activeTransition = {
        duration: 2.5,
        ease: "easeInOut",
        repeat: Infinity, // Loop infinitely
        repeatType: "loop", // Repeats the loop animation
    }


    return <Tooltip title={"Add to Search"} placement={"top"} style={{height: '100%'}}>
        <div style={{height: '100%', marginBottom: 8,}}>
            <motion.div style={active ? activeStyle : inactiveStyle} animate={active ? activeAnims : {}} transition={active ? activeTransition : {duration: 0}}>
                <SearchIcon style={{
                    fontSize: 32,
                    padding: 0,
                    // marginBlock: 'auto',
                    zIndex: 1000,
                    color: active ? "#7fbcfd" : 'gray'
                }} onClick={() => {
                    active && clickFunc()
                }}/>
            </motion.div>
            {/* OLD SPINNY PULSE, would probably be better to just revert to that commit if you want this cause of style changes. */}
            {/*{active && <motion.div*/}
            {/*    initial={{borderRadius: "50%", scale: 1, rotate: 0, backgroundColor: "rgba(86,182,218,0.25)"}}*/}
            {/*    animate={{*/}
            {/*        scale: [1, 1.05, 1], // Pulsing effect*/}
            {/*        rotate: [0, 360], // Full rotation*/}
            {/*        height: [38, 40, 38],*/}
            {/*    }}*/}
            {/*    transition={{*/}
            {/*        duration: 3,*/}
            {/*        ease: "easeInOut", // Smooth easing function*/}
            {/*        repeat: Infinity, // Loop infinitely*/}
            {/*        repeatType: "loop", // Repeats the loop animation*/}
            {/*    }}*/}
            {/*    style={{*/}
            {/*        position: "absolute", // Absolute position relative to parent*/}
            {/*        zIndex: 1,*/}
            {/*        height: 38,*/}
            {/*        width: 38,*/}
            {/*        top: -3, // Center vertically*/}
            {/*        left: 5, // Center horizontally*/}
            {/*        transform: "translate(-50%, -50%)", // Center behind the icon*/}
            {/*        overflow: "hidden",*/}
            {/*        willChange: "transform, height, width",  // This might not be needed but it should reduce repaints supposedly.*/}
            {/*    }}*/}
            {/*/>}*/}
        </div>
    </Tooltip>
}